const translationsEn = {
    _lang: "عربي",
    LANGUAGE_NAME: "English",
    USERNAME: "Username",
    PASSWORD: "Password",
    LOGIN: "Login",
    SYSTEM_NAME: "Admission System",
    ALL_NEWS: "All News",
    STUDENTS: "Students",
    COPY_RIGHT: "Copyright",
    CITC: "Intlaq for Communications and Information Technology",
    REFUND_POLICY: "Refund Policy ",
    PRIVACY_POLICY: "Privacy Policy",
    PRIVACY_POLICY_TITLE: "Privacy and Data Protection Policy",
    TERMS_RULES: "Terms and Conditions",
    CITC_BRIEF: "CITC",
    MANS: "Mansoura University",
    CONTACT_US: "Contact Us",
    CHANGE_LANGUAGE: "Change Language",
    ACCOUNT: "Account",
    NOTIFICATIONS: "Notifications",
    SCOPE: "Change Scope",
    ACADEMIC_YEAR_SEMESTER: "Change The Academic Semester and Year",
    PROFILE: "Profile",
    LOGOUT: "Logout",
    FORGOT_PASSWORD: "Forgot Password?",
    UPDATE_MAIL_TO_ACTIVATE: 'resend email to activate account',
    ADMISSION_GATE: 'Electronic Admission Gate ',
    CLOSE: "Close",
    SUCCESSED_LOGIN: "Successed Login",
    USERNAME_MAX: "Username mustn't Exceed 70 Characters",
    USERNAME_REQUIRED: "Username is Required",
    PASSWORD_MAX: "Password mustn't Exceed 20 Characters",
    PASSWORD_REQUIRED: "Password is Required",
    ACADEMIC_SEMESTER: "Semester",
    ACADEMIC_YEAR: "Academic Year",
    BACK: "Back",
    SAVE: "Save",
    CANCEL: "Cancel",
    CREDENTIAL_ERROR: "Username or Password is Wrong",
    NOT_FOUND_SERVER_ERROR: "Bad Request, Please Call Customer Service",
    AR_NAME: "Arabic Name",
    EN_NAME: "English Name",
    NAME: "the Name",
    STUDENT_NAME: "Student Name",
    SIGNATURE: "signature",
    STUDENT_SIGNATURE: " student signature",
    IS_ACTIVE: "Is Active",
    ADD_NEW: "Add",
    EDIT: "Edit",
    DELETE: "Delete",
    YES: "Yes",
    NO: "No",
    PRINT: "Print",
    PRINT_APPLICATION: "Print Admission Application",
    PRINT_DESIRE_FORM: " Print Desire Form",
    DESIRE_FORM: "Desire Form",
    COUNT: "Count Per Page",
    SUCCESS: "Saved Successfully",
    REQUIRED_FIELD: "This Field is Required",
    BIRTHDATE_MAX: "Birthday must not exceed today",
    ACTIVE: "Active",
    NOT_ACTIVE: "Not Active",
    ACTIVATION: "Activation",
    NO_DATA: "No Available Data",
    ARABIC_FIELD: "Enter Arabic Letters Only",
    ENGLISH_FIELD: "Enter English Letters Only",
    ACTIONS: "Actions",
    MAX_FIELD: "Max Length of this Field must be less than ",
    MIN_FIELD: "Max Length of this Field must be greater than ",
    CONFIRM: "Confirm",
    CONFIRMATION_MESSAGE: "Confirmation Message",
    WARNING: "warning",
    DELETE_CONFIRMATION: "Are you sure you want to delete?",
    PREVENT_NUMBERS_IN_FIRST: "This Field mustn't start with Numbers",
    ACTIVATE: "Activate",
    DEACTIVATE: "De-activate",
    NEED_HELP: "Do you need help ?",
    STATUS: "Status",
    YEAR: "Year",
    RESET: "Reset",
    SEARCH: "Search",
    TOTAL: "Total",
    OPENED: "Opened",
    CLOSED: "Closed",
    ROWS_PER_PAGE_TEXT: "Rows per page:",
    PAGE_TEXT: "Of",
    USERNAME_VALIDATION:
        "This field consists of English letters and numbers only and not less than 3 letters",
    NID_VALIDATION: "The national number is incorrect",
    PASSPORT_VALIDATION:
        "Incorrect passport number must contain English letters and numbers only",
    EMAIL_VALIDATION:
        "Please follow this email format user@domain.xxx and account name must not exceed 64 characters",
    PREVENT_SPECIAL_CHARACTER_FIELD:
        "This field must not contain special character",
    PASSWORD_VALIDATION:
        "Enter complex password at least one capital letter, a number and a special character",
    CONFIRM_PASSWORD_VALIDATION: "Password does not match",
    EMAIL: "E-mail",
    CONFIRM_PASSWORD: "Confirm Password",
    NID: "National ID",
    RE_ENTER_NID: "Re enter previous national Id",
    RE_ENTER_EMAIL: " enter mail to activate account  ",
    PASSPORT: "Passport Number",
    CREAT_ACOUNT: "Create Account",
    CREAT_ACOUNT_IN: "Create Account in ",
    LOGIN_INSTEAD: "Login Instead",
    REGISTER: "Register",
    DOWNLOAD_CONSENT_FILE: "Download consent file",
    DOWNLOAD_CONSENT_NOTES: " please download file and re upload file again ",
    USERNAME_EMAIL: "Username / Email",
    GO_TO_LOGIN_CONFIRMATION:
        "Do you want to go to the login page instead of creating an account?",
    PRIVACY_POLICY_POINTS: {
        POINT1: "- All data recorded in the system is the property of the entity that owns it.",
        POINT2: "- Company engineers do not access the data except in extreme necessity and solely for technical support, and only with verbal or written agreement from the data-owning entity.",
        POINT3: "- No system data shall be shared with any individual or sub-entity belonging to the data owner, or with any third party, without written approval from the data-owning entity.",
        POINT4: "- System data may be used to generate statistics that help measure the system’s performance and efficiency of use.",
        POINT5: "- All system data is secured through server protection, secure data transmission between the user’s device and the server, and protection of the system’s user interface.",
        POINT6: "- Each system user is fully responsible for their password and must take all possible precautions to prevent others from accessing it.",
    },
    REFUND_POLICY_POINTS: {
        POINT1: "- All payments made through the website are final and non-refundable, except in the case of a documented technical or administrative error during the payment process.",
        POINT2: "- In such cases, the user may request a refund by providing proof of the error. ",
        POINT3: "- If a refund is to be issued, all refund requests are subject to review and approval by the relevant administration. ",
    },
    TERMS_RULES_POINTS: {
        POINT1: "- The website offers an electronic tuition payment service on behalf of contracted educational institutions. Payments are sent directly to the accounts of the educational institutions based on the information provided by the user.",
        POINT2: "- The user is responsible for the accuracy and correctness of the data submitted during the payment process.",
        POINT3: "- Additional service fees may be applied to each electronic payment. These fees are clearly displayed to the user before completing the transaction.",
        POINT4: "- The website uses advanced security protocols to protect financial and personal data. However, the user acknowledges their responsibility to keep their payment information confidential and not to share it with others.",
        POINT5: "- The website is not liable for any delays or failures in completing the transaction due to technical issues beyond our control or due to the user’s misuse of the website in violation of the law or the stated terms.",
        POINT6: "- The website reserves the right to amend these terms and conditions at any time without prior notice. Continued use of the website after such changes constitutes implicit acceptance of the new terms.",
    },

    ADMISSION_DATA: {
        APPLICATION_ID: "Application ID",
        APPLICATION_DATE: "Application Date",
        APPID: "Application ID",
        NEXT: "Next",
        UPLOAD_IMG: "Change Image",
        BACK: "Back",
        SAVE: "Send",
        DRAFT: "Save as draft",
        TERMS:
            "I certify that all the information shown in the application statement is correct and completely in accordance with my personal documents and I bear responsibility for any errors in it without any responsibility on the system or the auditors",
        GO_TO_APP_LIST_CONFIRMATION:
            "Do you want to go to your Applications List ?",
        IMAGE_ATTACHED: "Attached Image",
        APP_STATUS: "Application Status",
        APP_STATUSES: [
            "Draft",
            "Under Reviewing",
            "Accept",
            "Reject",
            "To Be Completed"
        ],
        STEP1: {
            NAME: "Personal Data",
            AR_FULLNAME: "Full Name in Arabic",
            EN_FULLNAME: "Full Name in English",
            ID: "Identity number",
            IDTYPE: "",
            ID_IMAGE: "Identification Image",
            NATIONALID: "National ID",
            PASSPORT: "Passport",
            IDHINT: "National Id or passport",
            TYPE: "Gender",
            FEMALE: "Female",
            PHONE: "Mobile Number",
            TELEPHONE: "Telephone Number",
            MALE: "Male",
            MUSLIM: "Muslim",
            CHRISTIAN: "Christian",
            RELIGION: "Religion",
            EMAIL: "E-Mail",
            BIRTHDATE: "Birth Date",
            IMAGE: "Personal Image",
            COUNTRY: "Country",
            STATE: "province/state",
            CITY: "City",
            NATIIONALITY: "Country of Nationality",
            ADDRESS: "Address",
            BIRTHPLACE: "Birth Place",
            CONTACTS: "Contact Details",
            PERSONAL_DATA: "Personal Data",
            BIRTH_CERT: "Birth Certificate",
            GUARDIAN_CARD: "Guardian Card",
            MILITARY_FORM: "Military Form(Optional)"
        },
        STEP2: {
            NAME: "Qualificationَ",
            CERTIFICATION: "Certification Type",
            MAJOR: "Major",
            YEAR: "Qualification Year",
            SEATNO: "Seat number for egyptian secondary degree only",
            SUM: "Sum",
            PULL_SECONDARY_DATA: "pull my data",
            PERCENTAGE: "percentage",
            EQUIVALENT_CERT_TYPE: "Equivalent Certification Type",
            CERT_FROM_COUNTRY: "From Country",
            CERTIFICATE_IMAGE: "Certification Image",
            CERTIFICATE_FILE: "Certificate PDF or image File",
            CERTIFICATE_IMAGE2: "Certification Image2",
            CERTIFICATE_IMAGE3: "Certification Image3",
            RECEIPT_IMAGE: "payment receipt image ",
            CONSENT_FILE: "Consent File ",
            STU_RESIDENCE_IMAGE: "Student Residence Image",
            LEGAL_GUARDIAN_RESIDENCE_IMAGE: "Legal Guardian Residence Image ",

            CERTIFICATE_NAME: "Certification Name",
            TOTAL_MIN: "Certification total degree should be more than 0",
            TOTAL_MAX: "Certification total degree shouldn't be more than 999999 and percentage over 200%",
            TOTAL_PERC_GS_MAX: " percentage should be between 0: 100% ",
        },
        STEP3: {
            NAME: "Application",
            ACDYEAR: "Academic Yearِ",
            SEMESTER: "Semester",
            FACULTY: "Faculty",
            DESIRE: "Desire ",
            BRANCH: "Branch",
            MESSAGE: "Select Faculty and check below terms and condition to complete your application",
            TERMS: "Terms and Conditions",
            ADMISSION_TERMS: "Admission Terms and Conditions",
            CHECK: "Confirm",
            SAVE: "Send",
            CANCEL: "Cancel",
            NEXT_CONFIRMATION: "The application data will be saved as a draft and will be submitted automatically after payment so Kindly review your application details first.Accept?",
            NEXT_INITIAL_CONFIRMATION: "The application data will be saved as an initial draft and will be submitted automatically after payment so Kindly review your application details first.Accept?",
            NEXT_CONFIRMATION_WITHOUT_PAYMENT: "The application data will be sent  in next step  so Kindly review your application details first.Accept? "
            ,FACULTY_CHOSEN:"faculty chosen before! "
            ,ALL_FACULTY_CHOSEN:"all available faculties already chosen before! "

        },
        STEP4: {
            LINE1: "due to review your admission application please you must pay  ",
            PAYMENT_PRICE: "1500 L.E",
            RECEIPTNUM: "Receipt num",
            LINE1CONT: "using fawry service and you can know payment code bu click below",
            LINE2: "you must insure that:",
            LINE3: "1 - all your admission data and file are correct .",
            LINE4: "2 -pay fees as without payment your application can't be reviewed .",
            LINE5: "note that :",
            LINE6: "1. payment code is expired after 5 hours from it's generation .",
            LINE7: "2. في حالة استخراج كود سداد ولم يتم الدفع خلال 5 ساعات من توقيت تقديم الطلب تستطيع اعادة طلب كود سداد للدفع مرة أخرى من خلال الرابط الذي يظهر أمامك وسيتم انشاء كود جديد حتى تتمكن من الدفع من خلاله.",


            NAME: "Pay & submit",
            EXPIRYPERIOD: "Available until",
            TABLETITLE: "Payment Details",
            PERIOD: "Three days",
            PAID: "Paid",
            REFERENCENUM: "Reference Number",
            PAIDDATE: "Payment Date",
            // TITLE: "In order to be able to submit the application, please pay the application fee online via Fawry or Banque Misr and Kindly review your application details because  the application will be submitted automatically once you paid",
            TITLE: "In order for your application to be considered, please pay the application fee online via Fawry service and to find out the account, you must go to the university to take it, and please make sure to review the application data, because by completing the payment process the application is considered.",
            // or Banque Misr, or pay on the university's account,
            // PAYMENT_PRICE:"The payment data due is",
            TAXS: "in addition to commission payment",
            TECHNICAL_SUPPORT: "If a problem occurs, please call the following numbers: 16541",
            ONLINE_PAYMENT: "To pay online",
            BANK_PAYMENT: "To send the order",
            CLICK_HERE: "Click here",
            LE: "L.E",
            HAS_REFRENCE_NOT_PAID:
                "your order # {paymentNum} is pending please pay the fees The validity of the reference number is 5 hours from date {paymentDate} You can pay the fees from any endpoint payment machine or through (Visa/Bank Misr) to pay through them",
            HAS_REFRENCE_PAID: "your order  # {paymentNum} has been paied successfully",
            EXPIRED: "your order # {paymentNum} is expired",
            NOTE: "Note:",
            NOTE1: "1- In the case of extracting a reference number and it has not been paid within 5 hours, you can re-request a reference number to pay again through the link that appears in front of you and another number will be created so that you can pay on it",
            NOTE2: "2- In case that you choose to send the application and pay via the bank later, the application will not be considered unless the payment process is completed.",
        }
    },
    UserData: {
        PROFILE: "Profile",
        PROFILE_EDIT: "Edit Profile",
        PERSONAL_DATA: "Personal Information",
        CONTACT: "Contact Information",
        CERTIFICATE: "Qualification Data",
        APPLICATION: "Application Data",
        FACULTY: "faculty",
        APPLICATION_ID: "application Id",
        APPLICATION_STATUS: "application status",
        DESIRE_NUMBER: "desire Number",
        AVATAR: "Profile Picture",
        AR_NAME: "Name in Arabic",
        EN_NAME: "Name in English",
        NATIONALITY: "Nationality Country",
        NATIONAL_ID: "National Id",
        PASSPORT: "Passport",
        GENDER: "Gender",
        MALE: "Male",
        FEMALE: "Female",
        BIRTHDAY: "Birthday",
        PHONE: "Phone Number",
        MOBILE: "Mobile Number",
        ADDRESS: "Address",
        BIRTHPLACE: "Birth Place",
        COUNTRY: "Country",
        STATE: "Governorate / State",
        CITY: "City",
        EMAIL: "E-mail",
        CERTIFICATE_TYPE: "Certification Type",
        CERTIFICATE_DEPT: "Department",
        CERTIFICATE_YEAR: "Year",
        CERTIFICATE_RESULT: "Total / GPA",
        CERTIFICATE_PERC: "Percentage",
        CERTIFICATE_RESULT_MAX: "Total / GPA should be less than or equal 9999",
        CERTIFICATE_Egy_MAX: "Total / GPA should be less than or equal 410",
        CERTIFICATE_EQ_TYPE: "Equation Certification",
        CERTIFICATE_OTHER: "Certification Name",
        CERTIFICATE_FOREIGN_TYPE: "Certification Name",
        CERTIFICATE_EGYPTIAN_TYPE: "Egyptian Certification Name",
        CANCEL_CONFIRMATION: "Do you want to go to the profile page?",
        PIC_DELETE_CONFIRMATION:
            "Do you want to delete and change  picture?",
        SAVE_CONFIRMATION:
            "Do you want to save and change profile data with the provided data?",
        CHANGE_PASSWORD: "Change Password",
        NEW_PASSWORD: "New Password",
        CONFIRM_NEW_PASSWORD: "Confirm New Password",
    },
    APPLICATION_TITLE:
        "Application for admission to the academic year {appYear}, {appSemeter} semester",
    ALPHA_NUMERIC_FIELD: "This field must be contains only Letters and numbers",
    COMPLETE_DATA_ERROR: "Please, fill the profile information correctly to save",
    NUMBER_FIELD: "This Field must be Consists of Numbers Only",
    UNSIGNED_FLOAT_NUMBER_FIELD:
        "This field must be consists of positive numbers only",
    IMAGE_SIZE_VALIDATION: "Image size should be less than or equal 5 MB",
    IMAGE_EXTENTION_VALIDATION: "This Field must be Contains Image with Other Extensions",
    PDF_EXTENTION_VALIDATION: "This Field must be Contains PDF /images Extensions",
    NEW_APPLICATION: "Add New Application",
    APPLICATIONS: "List Applications",
    REORDER_APPLICATIONS: "Reorder desires",
    DESIRE_NUMBER: " Desire Number ",
    ARRANGE_DESIRES: "Arrange your desires",
    YOU_HAVE_UNSAVED_DESIRES: "The order of desires has not been re-saved yet. Do you want to print?",
    DESIRE_ORDER: "Desire Order",
    SAVE_ORDER: " save the order",
    DESIRE_MESSAGE: "You cannot rearrange your wishes at this time.",
    DESIRE_CONFIRMATION: "Are you sure you want to rearrange your desires as they are before saving?",
    PRINT_DATE: "print Date",
    INTERNAL_MAIL: "Internal Mail",
    SUGGESTIONS: "Suggestions",
    SERIAL: "N",
    FACULTY: "Faculty",
    APPLICATION_DATE: "Application Date",
    HOME: "Home",
    UNIVERSITY: "University",
    INSTRUCTIONS: "General Instructions",
    DRAFT_APPLY: "Draft",
    INITIAL_DRAFT_APPLY: "Initial Draft",
    UNDER_REVIEW: "Under Review",
    INITIAL_UNDER_REVIEW: "Initial Under Review",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
    TO_BE_COMP: "To Be Completed",
    IMPORTANT_NOTES: "Important Notes",
    ACKNOWLEDGMENT: "Acknowledgment",
    IMPORTANT_NOTES_TEXT:
        "This card is merely a notification to the student at the college to which it is submitted " +
        "and is not considered a document for the student’s enrollment in it.",
    NO_NOTIFICATIONS: "No Notifications For Now",
    MOBILE_VALIDATION: "Enter Mobile Number with Correct Format",
    SEND_NEW_PASSWORD: "Send New Password",
    SEND_ACTIVATION_CODE: "Sens Activation Code",
    NATIONALITY_REQUIRED: "Nationality is Required",
    END_APP_DATE: "Application Period is Expired",
    FUTURE_DATE: "Please Enter Past Date",
    FUTURE_DATE_RANGE: "Age must be greater than 14 and less 31 years old",
    VALID_DATE_RANGE:
        "Age must not be lower than 14 years, or bigger than 31 years",
    CONFIRM_CANCEL: "Do You Want To Cancel And Go Back?",
    ACCEPT_CANDIDATE: "Acception Candidate",
    REJECT_CANDIDATE: "Rejection Candidate",
    SEND_NO_FEES: "Under Review (no fees added )",
    TRANSFERRED: "transfered to students affairs system",
    REFUSED_AS_OTHER_ACCEPTED: " another application accepted",
    WAITING: "waiting list",
    PRINT_NOMINATION_CARD: " print nomination card",
};
export default translationsEn;
